import React, { Component } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap'
import { Helmet } from 'react-helmet'
import './index.css'

import { CSVBoxButton } from '@csvbox/react'
import Cookies from 'js-cookie';
import Postman from '../../utils/service';
import SweetAlert from 'react-bootstrap-sweetalert';

class Co_Op extends Component {

    constructor() {
        super()
        this.state = {
            user_id: null,
            isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
            showAlert: false,
            alertType: '',
            alertTitle: '',
            alertMessage: ''

        }
    }

    componentDidMount() {
        if (!this.state.user_id)
            Postman.getUserDetail().then((res) => {
                console.log(res.data.user.id)
                this.setState({ user_id: res.data.user.id });
            });
    }

    showAlert(type, message) {
        this.setState({
            alertType: type,
            showAlert: true,
            alertTitle: type === 'success' ? 'Import was Successful' : 'Opps!',
            alertMessage: message
        })
    }



    render() {
        return (
            <div className="animated fadeIn mainView">
                <Helmet>
                    <title>The Growjo Co-Op</title>
                    <meta name="description" content="The Growjo - Co-Op" />
                    <meta name="author" content="Growjo"></meta>
                </Helmet>
                <Card>
                    <SweetAlert
                        success={this.state.alertType === 'success' ? true : false}
                        warning={this.state.alertType === 'warning' ? true : false}
                        confirmBtnText="Close"
                        confirmBtnBsStyle="primary"
                        title={this.state.alertTitle}
                        show={this.state.showAlert}
                    >
                        {this.state.alertMessage}
                    </SweetAlert>
                    <CardHeader className='cardHeader'>
                        <h1 style={{ color: '#474866', marginBottom: 0 }}>The Growjo Co-Op</h1>
                    </CardHeader>
                    <CardBody>


                        <h2>How it Works</h2> <br/>
                        <h3>Upload Your Contacts</h3>
                        <p>As a user you can upload your own contacts from any data source including your CRM, your own Contact lists and Linkedin connections, etc.</p>

                        <h3>Receive 1 Credit Contact for each Contact Uploaded</h3>
                        <p>For every approved contact uploaded, you will receive 1 credit to unlock/export a contact within our database.</p>

                        <h3>How to Export Linkedin Connections</h3>
                        <ol>
                            <li>Go <a target="_blank" href="https://www.linkedin.com/mypreferences/d/download-my-data">here</a></li>
                            <li>
                                Check off these options and click Request Archive <br/>
                                <img className='bg-white mb-4 mt-3 p-3 rounded shadow' width="600" src='/static/img/linkedin-steps.png' alt="" />


                            </li>
                            <li>After you download your contacts via email, import them using the instructions below</li>
                        </ol>

                        <h3>How to Import Your Contacts</h3>
                        <ol>
                            <li>Use our Importer from below button</li>
                            <li>When your contacts approved we will add your bonus contacts and send you an email</li>
                        </ol>

                        <div className='text-center'>

                            {this.state.user_id && <CSVBoxButton
                                licenseKey="UpRSsVxFxUzhees1v6H7pl3fRKFCO9"
                                user={{
                                    user_id: this.state.user_id
                                }}
                                onImport={(result, data) => {
                                    if (result) {
                                        // console.log("success");
                                        // console.log(data.row_success + " rows uploaded");
                                        //custom code
                                        this.showAlert('success', 'We will send you an email when your credits have been added.')
                                    } else {
                                        console.log("fail");
                                        this.showAlert('error', 'Something went wrong, please try again')
                                    }
                                }}
                                render={(launch, isLoading) => {
                                    return <button className='btn btn-primary btn-lg' disabled={isLoading} onClick={launch}>
                                        Upload file &nbsp;
                                        <i className='fa fa-upload'></i>
                                    </button>;
                                }}
                            >
                                Import
                            </CSVBoxButton>}
                        </div>

                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default Co_Op;



// WEBPACK FOOTER //
// ./client/src/views/Co_Op/index.js